module.exports = __webpack_public_path__ + "static/media/CHUONGTRINHGIANGDAY-05.0c9d63dd.png";